import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { MdArrowDropDown, MdArrowOutward, MdClose, MdMenu } from 'react-icons/md';
import './event_navigation.css';
import proptechLogo from './Proptech Club Horizontal.png';

const EventNavigation = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [partnersOpen, setPartnersOpen] = useState(false);

    useEffect(() => {
        if (!menuOpen && !partnersOpen) {
            return undefined;
        }

        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                setMenuOpen(false);
                setPartnersOpen(false);
            }
        };

        if (menuOpen) {
            document.body.style.overflow = 'hidden';
        }
        window.addEventListener('keydown', handleEscape);

        return () => {
            if (menuOpen) {
                document.body.style.overflow = '';
            }
            window.removeEventListener('keydown', handleEscape);
        };
    }, [menuOpen, partnersOpen]);

    const closeMenu = () => {
        setMenuOpen(false);
        setPartnersOpen(false);
    };

    return (
        <nav className="event-nav">
            <div className="event-nav-container">
                <Link className="event-nav-logo" to="/" onClick={closeMenu}>
                    <img src={proptechLogo} alt="PropTech Club Logo" />
                </Link>
                <button
                    className="event-nav-toggle"
                    type="button"
                    onClick={() => setMenuOpen((isOpen) => !isOpen)}
                    aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
                    aria-expanded={menuOpen}
                    aria-controls="event-nav-links"
                >
                    {menuOpen ? <MdClose aria-hidden="true" /> : <MdMenu aria-hidden="true" />}
                </button>
                <button
                    className={`event-nav-sidebar-backdrop${menuOpen ? ' event-nav-sidebar-backdrop-open' : ''}`}
                    type="button"
                    onClick={closeMenu}
                    aria-label="Close navigation menu"
                    tabIndex={menuOpen ? 0 : -1}
                />
                <div
                    id="event-nav-links"
                    className={`event-nav-links${menuOpen ? ' event-nav-links-open' : ''}`}
                >
                    <NavLink to="/" end onClick={closeMenu} className={({ isActive }) => `nav-link${isActive ? ' nav-link-active' : ''}`}>Home</NavLink>
                    <NavLink to="/proptech-club/about" onClick={closeMenu} className={({ isActive }) => `nav-link${isActive ? ' nav-link-active' : ''}`}>About</NavLink>
                    <NavLink to="/gallery" onClick={closeMenu} className={({ isActive }) => `nav-link${isActive ? ' nav-link-active' : ''}`}>Gallery</NavLink>
                    <div className={`nav-partners${partnersOpen ? ' nav-partners-open' : ''}`}>
                        <button
                            className="nav-link nav-partners-trigger"
                            type="button"
                            onClick={() => setPartnersOpen((isOpen) => !isOpen)}
                            aria-expanded={partnersOpen}
                            aria-haspopup="true"
                        >
                            Events
                            <MdArrowDropDown aria-hidden="true" />
                        </button>
                        <div className="nav-partners-dropdown" aria-label="Partner options">
                            <Link to="/events/apex" className="nav-partners-item" onClick={closeMenu}>APEX</Link>
                            <Link to="/events/ARCE" className="nav-partners-item" onClick={closeMenu}>ARCE</Link>
                            <Link to="/events/airex" className="nav-partners-item" onClick={closeMenu}>AIREX</Link>
                        </div>
                    </div>
                    <NavLink to="/proptech-times" onClick={closeMenu} className={({ isActive }) => `nav-link${isActive ? ' nav-link-active' : ''}`}>PropTech Times</NavLink>
                    <a className="nav-link nav-link-external" href="https://blog.proptechclub.org" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
                        Blogs
                        <MdArrowOutward aria-hidden="true" />
                    </a>
                    <Link to="/membership" className="nav-member-btn" onClick={closeMenu}>Become A Member</Link>
                </div>
            </div>
        </nav>
    );
};

export default EventNavigation;
